import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectIsAutoRefresh } from 'src/app/pages/active-calls/state/account-active-calls/account-active-calls.selectors';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';
import { accountCallDetailsAdded, accountCallDetailsUpdated } from './call-details-hub.actions';
import { CallDetailsHubBase } from './call-details-hub.base';

@Injectable()
export class AccountCallDetailsHubService extends CallDetailsHubBase {
   wireUpHubEvents(): void {
      this.init(this.store.select(selectIsAutoRefresh));
   }

   protected init(selector: Observable<boolean>): void {
      this.autoRefresh$ = selector;

      this.autoRefresh$.pipe(takeUntil(this.destroyed$)).subscribe((isAutoRefresh) => {
         this.ndtHubService.connection.on('AddCallDetail', (callDetail) => {
            if (isAutoRefresh) {
               this.store.dispatch(accountCallDetailsAdded({ callDetail }));
            }
         });

         this.ndtHubService.connection.on('UpdateCallDetail', (callDetail) => {
            if (isAutoRefresh) {
               this.store.dispatch(accountCallDetailsUpdated({ callDetail }));
            }
         });
      });
   }

   constructor(ndtHubService: NdtHubConnectionService, store: Store) {
      super(ndtHubService, store);
   }
}
